import type { FaireProductEntity } from "../../entity_types/product";

export const p_jn8ekbynsm: FaireProductEntity = {
  token: "p_jn8ekbynsm",
  type: "product",
  name: "Shell & Pearl Necklace (Handmade)",
  brandName: "The Salty Gem",
  imageUrl:
    "https://cdn.faire.com/fastly/c2fbde05360013ec9aeb7f62bf1e62211df9d0ade389cdbaa8265049093c26c0.png",
  priceDollars: 29,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/812682253f046645cd5f1a6757175cb1cdc386a80ff210086bee512523024c0d.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
